<template>
  <a-form :colon="false">
    <div class="control">
      <a-button-group size="small">
        <Notice
          :disabled="disabled"
          :noticeList="noticeList"
          :selectedKey="selectedKey"
          @setNoticeList="setNoticeList"
        />

        <template v-if="showAuditReject">
            <a-dropdown :disabled="disabled">
                <a-menu slot="overlay" @click="handleMenuClick">
                    <a-menu-item key="2" class="menu-item">
                        <img class="icon" :src="approval2Image" alt />
                        驳回到发起人
                    </a-menu-item>
                    <a-menu-item key="5" class="menu-item">
                        <img class="icon" :src="approval2Image" alt />
                        驳回到指定人
                    </a-menu-item>
                    <a-menu-item key="3" class="menu-item">
                        <img class="icon" :src="approval3Image" alt />
                        终止
                    </a-menu-item>
                    <a-menu-item key="4" class="menu-item">
                        <img class="icon" :src="approval2Image" alt />
                        <Sign :visible="visible" @show="isShow">加签</Sign>
                    </a-menu-item>
                </a-menu>
                <a-button class="button">
                    <img class="icon" :src="approval7Image" alt />
                    更多
                </a-button>
            </a-dropdown>



        </template>
        <template v-else>
          <a-dropdown :disabled="disabled">
            <a-menu slot="overlay" @click="handleMenuClick">
              <!-- <a-menu-item key="1" class="menu-item">
                <img class="icon" :src="approval5Image" alt />
                驳回上一步
              </a-menu-item> -->
             
              <a-menu-item key="2" class="menu-item">
                <img class="icon" :src="approval2Image" alt />
                驳回到发起人
              </a-menu-item>
               <a-menu-item key="5" class="menu-item">
                <img class="icon" :src="approval5Image" alt />
                驳回到指定人
              </a-menu-item>
              <a-menu-item key="3" class="menu-item">
                <img class="icon" :src="approval3Image" alt />
                终止
              </a-menu-item>
              <a-menu-item key="4" class="menu-item">
                <img class="icon" :src="approval2Image" alt />
                <Sign :visible="visible" @show="isShow">加签</Sign>
              </a-menu-item>
            </a-menu>
            <a-button class="button">
              <img class="icon" :src="approval7Image" alt />
              更多
            </a-button>
          </a-dropdown>
        </template>
      </a-button-group>
    </div>
    <a-form-item>
      <template slot="label">
        意见
        <span v-if="showAuditReject" style="color: #ff4d4f; font-size: 12px; margin-left: 4px;">
          校审意见请在左侧的
          <span class="scroll-link" @click="scrollToWorkspace">成果审查工作区</span>
          或
          <span class="scroll-link" @click="scrollToAddOpinion">校核、审核、审定意见区</span>
          填写。
        </span>
      </template>
      <a-textarea
        :disabled="disabled"
        :value="detail.comment"
        @change="handleCommentChange"
        :auto-size="{ minRows: 3 }"
      />
    </a-form-item>
    <a-form-item label="打分" v-if="scoreVisible">
      <div class="left">
        <a-slider
          :disabled="disabled"
          :value="score"
          :max="100"
          @change="handleSliderChange"
          style="flex: 1"
        />
        <a-button-group size="small" style="margin-left: 8px">
          <a-button icon="minus" @click="reduceScore" :disabled="disabled" />
          <a-input
            :disabled="disabled"
            style="width: 40px"
            size="small"
            :value="score"
            @change="handleScoreChange"
          />
          <a-button icon="plus" @click="addScore" :disabled="disabled" />
        </a-button-group>
      </div>
    </a-form-item>

    <a-form-item label="项目核算模式" v-if="formulaVisible">
      <a-select :disabled="disabled" :value="formula" @change="handleFormulaChange">
        <a-select-option
          v-for="item in formulaList"
          :key="item.value"
          :value="item.value"
          :disabled="item.value === '2020'"
        >{{ item.name }}</a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item
      label="经营费用总额度"
      v-if="formulaVisible && (formula === '2022' || formula === '2023' || formula === '2024' || formula === '2025')"
    >
      <a-input-number
        :disabled="true"
        :min="0"
        :max="1"
        :value="formula === '2023' || formula === '2024' || formula === '2025'? 0.06 : factor"
        @change="handleFactorChange"
      />
    </a-form-item>

    <a-form-item label="是否需要财务审核" v-if="needFinancialApproval">
      <a-radio-group
        :disabled="disabled"
        :value="isFinancialApproval"
        @change="handleFinancialApprovalChange"
      >
        <a-radio
          v-for="item in [{
            name: '是',
            value: 1,
          }, {
            name: '否',
            value: 0,
          }]"
          :key="item.value"
          :value="item.value"
        >{{ item.name }}</a-radio>
      </a-radio-group>
    </a-form-item>

    <a-form-item label="" v-if="isBidJury" required>
      <a-radio-group
        :disabled="disabled"
        :value="passFlag"
        @change="(e) => (passFlag = e.target.value)"
      >
        <a-radio-button :value="true">审核通过</a-radio-button>
        <a-radio-button  :value="false">审核不通过</a-radio-button>
      </a-radio-group>
    </a-form-item>

    <!-- 工单处理记录输入区已移至左侧 OaWorkOrder 组件"处理记录"区块（参照原型图），
         数据存于 store.approval.workOrderRecord，提交时在 control() 中读取
    <template v-if="isOaWorkOrder && isWorkOrderProcessNode">
      <a-form-item label="问题类型" required>
        <a-radio-group :disabled="disabled" v-model="workOrderProblemType">
          <a-radio value="demand">需求</a-radio>
          <a-radio value="bug">故障</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="修改内容" required>
        <a-textarea
          :disabled="disabled"
          v-model="workOrderModifyContent"
          placeholder="请输入修改内容"
          :auto-size="{ minRows: 3 }"
          :max-length="2000"
        />
      </a-form-item>
      <a-form-item label="附件">
        <Uploader :list="workOrderProcessFiles" @change="(arr) => (workOrderProcessFiles = arr)" />
      </a-form-item>
    </template>
    -->

    <div class="center">
      <a-space>
        <a-button v-if="assignees && assignees.length" @click="tempSave">暂存</a-button>

        <a-button
          type="primary"
          @click="save"
          :disabled="disabled"
          :loading="loading"
        >{{ detail.status === "RESUBMITED" ? "重新提交" : "通过" }}</a-button>

        <template v-if="isOaWorkOrder && !disabled">
          <!-- 转单：仅工单处理人节点（task_process）可点击 -->
          <EmployeeSelector @change="onSelectTransferUser" :value="transferUser.userId ? [transferUser] : []">
            <a-button :disabled="detail.taskDefinitionKey !== 'task_process'">转单</a-button>
          </EmployeeSelector>
          <span v-if="transferUser.userId" style="color: #1890ff">
            {{ transferDeptName }} - {{ transferUser.name }}
          </span>
        </template>

        <a-button @click="rejectToStarter" v-if="showAuditReject" :disabled="disabled">驳回到发起人</a-button>
        <a-button @click="reapply" v-if="detail.status === 'RESUBMITED' && !oa_it_asset_transfer_dept && detail.processDefinitionKey !== 'cosys_design_archive'">修改后提交</a-button>

        <div v-if="assignees && assignees.length">
          加签人员
          <span style="color: #1890ff">({{ assignees.length }})</span>
        </div>

        <!-- 已办任务显示取回按钮：流程回到取回人待办重新处理；不能取回时置灰 -->
        <a-button v-if="showWithdraw" :disabled="!canWithdraw" @click="$emit('withdraw')">取回</a-button>
      </a-space>
    </div>

    <CommentModal
      :visible="commentVisible"
      :value="detail.comment"
      @setVisible="setCommentVisible"
      @done="onCommentDone"
    />

    <a-modal
      :visible="rejectModalVisible"
      title="提示"
      @cancel="handleRejectModalCancel"
    >
      <p>您已在左侧相关区域填写过校审意见，您确定不驳回至发起人吗?</p>
      <template #footer>
        <a-button @click="handleRejectModalCancel">取消</a-button>
        <a-button type="primary" @click="handleApprove">通过</a-button>
        <a-button type="primary" danger @click="handleRejectToStarter">驳回发起人</a-button>
      </template>
    </a-modal>

    <a-modal
      :visible="jumpModalVisible"
      title="驳回到指定人"
      :confirm-loading="jumpLoading"
      @cancel="jumpModalVisible = false"
      @ok="handleJumpSubmit"
    >
      <a-form-model :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="补审节点" required>
          <a-select
            v-model="jumpTargetNode"
            placeholder="请选择补审节点"
          >
            <a-select-option
              v-for="item in jumpNodeList"
              :key="item.taskDefKey"
              :value="item.taskDefKey"
            >{{ item.taskName }} - {{ (item.assigneeNames || []).join(',') }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="跳转模式" required>
          <a-radio-group v-model="jumpMode">
            <a-radio value="direct">补审后返回当前节点</a-radio>
            <a-radio value="sequence">补审后按原流程顺序往下走</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="意见">
          <a-textarea
            v-model="jumpComment"
            placeholder="请输入补审意见"
            :auto-size="{ minRows: 3 }"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-form>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import Notice from "../Notice";
import Sign from "./components/Sign";
import CommentModal from "@/components/comment-modal";
import EmployeeSelector from "@/components/employee-selector";
import Uploader from "@/components/uploader";
import { fetchJumpNodes, jumpToNode, checkAutoComplete } from "@/api/approval";


import approval7Image from "@/assets/approval7.png";
import approval2Image from "@/assets/approval2.png";
import approval3Image from "@/assets/approval3.png";
import approval5Image from "@/assets/approval5.png";

export default {
  components: {
    Notice,
    Sign,
    CommentModal,
    EmployeeSelector,
    Uploader
  },

  props: {
    // 详情任务是否为已办任务（控制取回按钮显示）
    showWithdraw: {
      type: Boolean,
      default: false
    },
    // 是否允许取回（false时取回按钮置灰）
    canWithdraw: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      noticeList: [], // 需要知会的人员列表
      selectedKey: "approvalDetail",
      loading: false,

      approval7Image, // icon
      approval2Image, // icon
      approval3Image, // icon
      approval5Image, // icon

      visible: false, //加签对话框的显示

      status: "", //用于判断从epc文件列表调过来时，是否可审核，若为COMPLETED为可审核，否则不可审核

      commentVisible: false, // 审批意见弹框
      pendingMap: null, // 暂存的待提交审批数据
      passFlag: null, // 评标委员会审批：是否通过
      rejectModalVisible: false, // 驳回确认弹框
      skipRejectModalCheck: false, // 跳过驳回弹框检查，直接通过

      jumpModalVisible: false, // 驳回到指定人弹框
      jumpNodeList: [], // 已走过的历史节点
      jumpTargetNode: undefined, // 目标节点 taskDefKey（undefined 才会显示占位符）
      jumpMode: "direct", // 跳转模式：direct-补审后返回当前节点，sequence-按原流程顺序
      jumpComment: "", // 补审意见
      jumpLoading: false,

      // 工单处理记录输入区已移至左侧 OaWorkOrder 组件，数据改存 store.approval.workOrderRecord
      // workOrderProblemType: "demand", // 工单处理记录-问题类型
      // workOrderModifyContent: "", // 工单处理记录-修改内容
      // workOrderProcessFiles: [], // 工单处理记录-附件
      transferUser: {}, // 转单选择的新处理人
    };
  },

  computed: {
    ...mapState("auth", ["user"]),

    // 当前选中补审节点（含 assigneeIds/assigneeNames）
    jumpAssigneeOptions() {
      return (
        this.jumpNodeList.find(
          item => item.taskDefKey === this.jumpTargetNode
        ) || {}
      );
    },

    // 当前审批任务 id：优先取任务详情，兜底 store
    currentTaskId() {
      return (
        (this.detail && this.detail.taskId) ||
        this.$store.state.approval.taskId
      );
    },
    ...mapState("approval", [
      "detail",
      "oldDelayedDate",
      "assignees",
      "signType",
      "history",
      "filteredOpinionList",
      "workOrderRecord"
    ]),
    ...mapState("approvalDetail", ["approvalList"]),
    ...mapGetters("approval", {
      isdisabled: "disabled"
    }),
    ...mapGetters("approval", [
      "scoreVisible",
      "score",
      "formulaVisible", // 产值分配计算公式
      "formula",
      "factor",
      "isSupervise",
      "isSuperviseWorker",

      "needFinancialApproval", // 是否需要财务审批
      "isFinancialApproval",

      "executeRemarks",
      "executeAttachments",
      "isDelayed",
      "delayedDate",
      "delayRemarks",

      "isInvoice",
      "isFinanceDrawer",

      "isManageObject",
      "isVisa",
      "isChangeApproval",
      "isSafeInspection",
      "isOrganizeDesign",
      "isQualityInspection",
      "isDataInspection",
      "isClaim",
      "isCounterClaim",
      "isBiddingResult",
      "isAddBidding", // 招标管理(创建标段)
      "isBiddingConfirm", // 中标通知确认审批

      "applyType",
      "invoiceList",
      "isPostMan",
      // "isConfirmer",
      "sendAttachment",
      // "isSent",

      "salesUnitName", // 销方名称
      "drawDate", // 开票日期

      "isPutOnFileRequest",
      "isBidRequestEPCLeader", // 项目投标申请(EPC-牵头人)
      "isBidRequestEPCLeaderNot",
      "isBidRequestDesign",

      "ofc_quality_rectify", // 安全生产-整改工作单

      "oa_it_asset_transfer_dept",

      "isReview",
      "isAudit",
      "isCosysStampReview",
      "isCosysPrjReview",
      "isCosysPrjTaskNotice",
      "isCosysDesignPlanRevise",
      "isCosysDesignPlan",
      "isCosysDesignCountersign",
      "isCosysStampPrint",
      "isCosysDesignAffirm",

      "isOaLeave",
      "isHrBranchEmployee",
      "isPurchaseMaterials",
      "isOaWorkOrder", // 工单申请

      "isCosysProjectFiling",
      "isCosysDesignReview",
      "isCosysProjectBidApply",
      "isCosysDesignChange",
      "isCosysDesignArchive",
      "isCosysDesignPlanSimple",
      "isCosysDesignInputReq",
      "isCosysMajorTransfer",
      "isCosysDesignService",
      "isCosysCompletionReport",
      "isCosysBlueprintReplace",

      "isContract", // 是否是合同审批
      "isContractSubpackageFirstReview", // 是否是合同分包初审节点
      "isContractRegisterJiruiNode", // 是否是收入合同审批吉瑞节点
      "assessmentYear", // 考核年份
      "undertakingMode", // 承接方式
      "businessGroupId", // 经营组ID
      "businessGroup", // 经营组名称
      "businessContactUserId", // 经营对接人ID
      "businessContactUserName" // 经营对接人名称
    ]),

    isSCRM() {
      return (
        this.isPutOnFileRequest ||
        this.isBidRequestEPCLeaderNot ||
        this.isBidRequestEPCLeader ||
        this.isBidRequestDesign
      );
    },

    ...mapGetters("setting", ["findDataDict"]),

    // 提示语集合
    messageList() {
      return this.findDataDict("message");
    },

    formulaList() {
      return this.findDataDict("pallocateCalcFormula");
    },

    // 考核年份列表
    assessmentYearList() {
      return this.findDataDict("pallocateCalcFormula");
    },

    // 承接方式列表
    undertakingModeList() {
      return this.findDataDict("contract_undertaking_method");
    },

    // 经营组列表
    businessGroupList() {
      return []; // 暂时返回空数组，后续根据实际数据源填充
    },

    disabled() {
      return this.isdisabled && this.status !== "RUNNING";
    },
    showAuditReject() {
      return this.isAudit && this.detail.status !== 'RESUBMITED';
    },
    isBidJury() {
      return (
        this.detail.processDefinitionKey === "mark_bid_jury" &&
        this.detail.taskDefinitionKey === "bid_reviewer"
      );
    },

    // 工单：当前是否为处理人节点（处理记录在此节点填写）
    isWorkOrderProcessNode() {
      const key = this.detail.taskDefinitionKey;
      return key === "task_process" || key === "task_transfer_process";
    },

    // 工单转单：所选新处理人的部门名称
    // employee/selection 返回的 employeeOrgVo 只有排序字段没有 name，部门名取 deptUniqueName
    transferDeptName() {
      const org = this.transferUser.employeeOrgVo || {};
      return org.name || this.transferUser.deptUniqueName || "";
    }
  },

  mounted() {
    const { status } = this.$route.query;
    this.status = status;
  },
  methods: {
    scrollToWorkspace() {
      this.scrollToAnchor('audit-workspace');
    },
    scrollToAddOpinion() {
      this.scrollToAnchor('audit-add-opinion');
    },
    scrollToAnchor(anchorId) {
      this.$nextTick(() => {
        const target = document.getElementById(anchorId);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    },

    ...mapMutations("approval", [
      "setDetail",
      "setScore",
      "setFormula",
      "setFactor",

      "addDrawer",
      "addDrawDate",

      "setSignUser",
      "setSignType",
      "setOnSet",

      "setIsFinancialApproval" // 设置财务审批
    ]),
    ...mapMutations("approval", [
      "setAssessmentYear", // 设置考核年份
      "setUndertakingMode", // 设置承接方式
      "setBusinessGroupId", // 设置经营组ID
      "setBusinessGroup" // 设置经营组名称
    ]),
    ...mapMutations("tabs", ["setTabList"]),
    ...mapActions("approval", [
      "finishTask",
      "signTaskStorage",
      "signTaskSubmit"
    ]),

    // 获取当前校审环节
    getCurrentStep() {
      const name = this.detail.name;
      if (name === '审定') return 'design_approver';
      if (name === '校核') return 'design_reviewer';
      if (name === '审核') return 'design_auditor';
      return '';
    },

    // 改变分数
    handleScoreChange(e) {
      const value = Number(e.target.value);

      if (!value) {
        this.setScore(0);
      } else if (value > 100) {
        this.setScore(100);
      } else {
        this.setScore(value);
      }
    },
    handleSliderChange(value) {
      this.setScore(value);
    },
    handleFormulaChange(value) {
      this.setFormula(value);
    },

    handleFinancialApprovalChange(e) {
      console.log(e.target.value);
      this.setIsFinancialApproval(e.target.value);
    },

    handleAssessmentYearChange(value) {
      this.setAssessmentYear(value);
    },

    handleUndertakingModeChange(value) {
      this.setUndertakingMode(value);
    },

    handleBusinessGroupIdChange(value) {
      this.setBusinessGroupId(value);
      // 同时设置经营组名称
      const selectedItem = this.businessGroupList.find(item => item.id === value);
      if (selectedItem) {
        this.setBusinessGroup(selectedItem.name);
      }
    },

    handleFactorChange(value) {
      this.setFactor(value);
    },
    reduceScore() {
      if (this.score === 0) {
        return;
      }
      this.setScore(this.score - 1);
    },
    addScore() {
      if (this.score === 100) {
        return;
      }
      this.setScore(this.score + 1);
    },

    // 驳回到发起人
    rejectToStarter() {
      this.pendingMap = {
        operation: "REJECTED_FIRST",
        comment: this.detail.comment
      };
      this.commentVisible = true;
    },

    // 用户点击取消审批
    handleMenuClick(e) {
      if (e.key === "1") {
        //  驳回至上一步
        // 若上一步的人为空， 弹窗提示只能驳回到发起人
        const index = this.history.findLastIndex(
          ite => ite.assignee === this.detail.assignee
        );

        if (this.history[index - 1].assignee === "none") {
          return this.$message.error("上一步审核人员未指定，只能驳回至发起人");
        }
        this.pendingMap = {
          operation: "REJECTED_LAST",
          comment: this.detail.comment
        };
        // 如果是招标管理，需要处理评标结果
        if (this.isBidJury) {
          this.passFlag = false
        }
        // 如果是
        this.commentVisible = true;
      } else if (e.key === "2") {
        // 驳回到发起人
        this.pendingMap = {
          operation: "REJECTED_FIRST",
          comment: this.detail.comment
        };
          // 如果是招标管理，需要处理评标结果
        if (this.isBidJury) {
          this.passFlag = false
        }
        this.commentVisible = true;
      } else if (e.key === "3") {
        const that = this;
        this.$confirm({
          title: this.messageList.find(item => item.value === "cancel-approval")
            .name,
          onOk() {
            that.pendingMap = {
              operation: "CANCELLED",
              comment: that.detail.comment
            };
            that.commentVisible = true;
          }
        });
      } else if (e.key === "4") {
        // 加签
        this.visible = true;
      } else if (e.key === "5") {
        // 驳回到指定人
        this.openJumpModal();
      }
    },

    // 驳回到指定人 - 打开弹框并加载历史节点
    openJumpModal() {
      const taskId = this.currentTaskId;
      console.log('==taskId', taskId);
      this.jumpTargetNode = undefined;
      this.jumpMode = "direct";
      this.jumpComment = this.detail.comment || "";
      this.jumpModalVisible = true;

      this.jumpLoading = true;
      fetchJumpNodes(taskId)
        .then(res => {
          this.jumpNodeList = Array.isArray(res) ? res : [];
        })
        .finally(() => {
          this.jumpLoading = false;
        });
    },

    // 驳回到指定人 - 提交
    handleJumpSubmit() {
      if (!this.jumpTargetNode) {
        this.$message.error("请选择补审节点！");
        return;
      }
      const assignees = this.jumpAssigneeOptions.assigneeIds || [];
      if (!assignees.length) {
        this.$message.error("该节点暂无补审人！");
        return;
      }

      this.jumpLoading = true;
      jumpToNode({
        taskId: this.currentTaskId,
        targetNodeKey: this.jumpTargetNode,
        assignees,
        jumpMode: this.jumpMode,
        comment: this.jumpComment,
      }).then(() => {
          this.$message.success("已跳转补审");
          this.jumpModalVisible = false;
          this.$emit("close");
        })
        .finally(() => {
          this.jumpLoading = false;
        });
    },
    //加签框的取消
    isShow() {
      this.visible = false;
    },

    // 提交审批
    save() {
      // 如果showAuditReject为true，且左侧校核、审核、审定意见中，
      // 对应环节与当前环节一致且处理意见为空，则弹出确认弹框
      if (
        this.showAuditReject &&
        !this.skipRejectModalCheck &&
        this.filteredOpinionList &&
        this.filteredOpinionList.length > 0
      ) {
        const currentStep = this.getCurrentStep();
        const hasEmptyReplyForCurrentStep = this.filteredOpinionList.some(
          item => item.step === currentStep && !item.reply
        );
        if (hasEmptyReplyForCurrentStep) {
          this.rejectModalVisible = true;
          return;
        }
      }
      this.skipRejectModalCheck = false;

      let map = {
        operation: "COMPLETED",
        comment: this.detail.comment
      };

      if (this.scoreVisible) {
        map.score = this.score;
      }

      if (this.formulaVisible) {
        if (!this.formula) {
          this.$message.error("请选择项目产值计算公式！");
          return;
        }
        if (this.formula === "2022" && !this.factor) {
          this.$message.error("请输入经营费用总额度！");
          return;
        }

        map.formula = this.formula;
        map.factor = this.formula === "2025" ||this.formula === "2024" || this.formula === "2023" ? 0.06 : this.factor;
      }

      if (this.needFinancialApproval) {
        if (typeof this.isFinancialApproval !== "number") {
          this.$message.error("请选择是否需要财务审批");
          return;
        }
        map.isFinancialApproval = this.isFinancialApproval;
      }

      if (this.isBidJury) {
        if (typeof this.passFlag !== "boolean") {
          this.$message.error("请选择评标结果");
          return;
        }
      }

      // 如果是合同分包初审节点，需要处理四个新字段
      if (this.isContractSubpackageFirstReview) {
        // 验证经营对接人：承接方式为增量时必填（值为 contract_undertaking_method_increment）
        if (this.undertakingMode === 'contract_undertaking_method_increment') {
          if (!this.businessContactUserId) {
            this.$message.error('承接方式为增量时，经营对接人必填！');
            return;
          }
        }
        
        map.assessmentYear = this.assessmentYear;
        map.undertakingMode = this.undertakingMode;
        map.businessGroupId = this.businessGroupId;
        map.businessGroup = this.businessGroup;
        map.businessContactUserId = this.businessContactUserId;
        map.businessContactUserName = this.businessContactUserName;

        // 同步到 extra，供后端 updateContract 解析
        if (!this.detail.extra.contractData) {
          this.detail.extra.contractData = {};
        }
        this.detail.extra.contractData.assessmentYear = this.assessmentYear;
        this.detail.extra.contractData.undertakingMode = this.undertakingMode;
        this.detail.extra.contractData.businessContactUserId = this.businessContactUserId;
        this.detail.extra.contractData.businessContactUserName = this.businessContactUserName;
      }

      // 如果是收入合同审批吉瑞节点，需要处理考核年份和承接方式
      if (this.isContractRegisterJiruiNode) {
        // 验证经营对接人：承接方式为增量时必填
        if (this.undertakingMode === 'contract_undertaking_method_increment') {
          if (!this.businessContactUserId) {
            this.$message.error('承接方式为增量时，经营对接人必填！');
            return;
          }
        }

        map.assessmentYear = this.assessmentYear;
        map.undertakingMode = this.undertakingMode;
        map.businessGroupId = this.businessGroupId;
        map.businessGroup = this.businessGroup;
        map.businessContactUserId = this.businessContactUserId;
        map.businessContactUserName = this.businessContactUserName;
      }

      // 如果是督办任务
      if (this.isSupervise) {
        map.executeRemarks = this.executeRemarks;
        map.executeAttachments = this.executeAttachments.map(item => item.id);
        map.delayedDate = this.delayedDate;
        map.delayRemarks = this.delayRemarks;
        // 默认没值，执行人填了延期字段，需要给后端，
        // 发起人看到延期有值，点击保存还是要给后端，后端拿着这值去用，而这一步其实是可以省略的，方便后端不用取值而已，
        // 流程回到了执行人这里，延期是有旧值得，这时候如果没改，就不给后端，改了才给后端。
        // 这里只改 map，extra 属于只读数据，只要保证是最新的即可。

        // 执行人要延期，isDelayed 必须设置为1，如果不延期，设置为0
        if (this.isSuperviseWorker) {
          if (!this.oldDelayedDate && !this.delayedDate) {
            // 新旧延期日期都没值，不延期
            map.isDelayed = 0;
          } else if (
            this.delayedDate &&
            this.oldDelayedDate !== this.delayedDate
          ) {
            // 都有值
            // delayedDate 旧值跟新值不一样，才申请延期，否则不延期
            if (
              this.detail.extra &&
              this.detail.extra.superviseTaskData &&
              this.detail.extra.superviseTaskData.originalDate
            ) {
              if (
                moment(
                  this.detail.extra.superviseTaskData.originalDate
                ).isSameOrAfter(this.delayedDate)
              ) {
                // 如果原来的办结时限比选择的延期日期还要晚，说明选择的延期不对
                this.$message.error("延期日期不得小于办结时限！");
                return;
              }
            }

            map.isDelayed = 1;
          } else {
            map.isDelayed = 0;
          }
        }
      }

      // 开票退票换票审批
      if (this.isInvoice) {
        // 财务开票
        if (this.isFinanceDrawer) {
          // 校验用户是否填写了发票的相关字段
          if (!this.salesUnitName) {
            this.$message.error("请选择销方！");
            return;
          }
          // 开票日期
          if (!this.drawDate) {
            this.addDrawer(this.user.userName);
            this.addDrawDate(moment().format("YYYY-MM-DD HH:mm:ss"));
          }

          // 退票/换票必须添加红冲票，发票列表不能为空
          // 原逻辑：只要不是退票就要校验（退票允许发票列表为空，作废由后端处理）
          // if (this.applyType !== "refund") {
          //   // 上传的发票数组为空
          //   if (this.invoiceList.length === 0) {
          //     this.$message.error("请上传发票！");
          //     return;
          //   }
          // }
          if (this.invoiceList.length === 0) {
            this.$message.error("请上传发票！");
            return;
          }

          // 退票/换票不区分旧票是否跨月，每张旧票必须添加金额为负数的红冲票
          if (this.applyType === "refund" || this.applyType === "change") {
            const oldInvoices =
              this.detail?.extra?.refundChangeInfo?.oldInvoices || [];
            for (const old of oldInvoices) {
              const hasRedFlush = this.invoiceList.some(
                (item) =>
                  item.oldInvoiceCode === old.oldInvoiceNo &&
                  parseFloat(item.invoicePrice) < 0
              );
              if (!hasRedFlush) {
                this.$message.error(
                  `请为旧发票${old.oldInvoiceNo}添加金额为负数的红冲票！`
                );
                return;
              }
            }
          }
        }
        // 填写送达信息
        if (this.isPostMan) {
          if (!this.sendAttachment) {
            this.$message.error("请上传送达附件！");
            return;
          }
        }

        // // 确认送达信息
        // if (this.isConfirmer) {
        //   if (!this.isSent) {
        //     this.$message.error("请选择是否送达！");
        //     return;
        //   }
        // }
      }

      // 工单申请：处理记录校验 + 转单
      if (this.isOaWorkOrder) {
        // 处理人节点：填写处理记录（校验后随extra提交，见下方extra组装处；附件为文件id列表）
        // 输入区已移至左侧 OaWorkOrder 组件，数据从 store.approval.workOrderRecord 读取
        if (this.isWorkOrderProcessNode) {
          // 处理人节点（task_process）：发生转单时无需填写处理记录，直接通过时必填；
          // 转单处理人节点（task_transfer_process）：必须填写修改内容
          const skipRecordCheck =
            this.detail.taskDefinitionKey === "task_process" && this.transferUser.userId;
          if (!skipRecordCheck) {
            if (!this.workOrderRecord.problemType) {
              this.$message.error("请选择问题类型！");
              return;
            }
            if (!this.workOrderRecord.modifyContent) {
              this.$message.error("请填写修改内容！");
              return;
            }
          }
          // map.problem_type = this.workOrderProblemType;
          // map.modify_content = this.workOrderModifyContent;
          // if (this.workOrderProcessFiles.length > 0) {
          //   map.process_attachment = this.workOrderProcessFiles
          //     .map((item) => item.completePath || item)
          //     .join(",");
          // }
        }
        // 是否收费：随map提交为流程变量，BPMN收费/不收费网关分支据此流转
        //（task_process后立即求值，转单时同样需要；task_process精确匹配）
        if (this.detail.taskDefinitionKey === "task_process") {
          map.is_charge = this.workOrderRecord.isCharge === true;
        }
        // 转单：将选择的新处理人作为下一审批节点的处理人
        // 注意：EmployeeSelector返回项的id是员工表id（0001N开头），流程assignee必须用userId（tb_user.uuid）
        // 转交人姓名/部门随extra提交（见下方extra组装处），业务回调解析extra反填业务字段
        if (this.transferUser.userId) {
          map.task_transfer_process = this.transferUser.userId;
          // const org = this.transferUser.employeeOrgVo || {};
          // map.transfer_handler_name = this.transferUser.name || "";
          // map.transfer_dept_id = org.id || "";
          // map.transfer_dept_name = org.name || "";
        }
      }

      // 如果有加签
      if (this.assignees?.length) {
        let arr = [
          {
            type: "counter_sign",
            operation: "COUNTER_SIGN"
          },
          {
            type: "sequential_sign",
            operation: "SEQUENTIAL_SIGN"
          },
          {
            type: "parallel_sign",
            operation: "PARALLEL_SIGN"
          }
        ];
        map.operation =
          arr.find(item => item.type === this.signType).operation || "";
        this.signTaskSubmit(map);
        this.$emit("close");
        return;
      }

      if (this.ofc_quality_rectify) {
        if (!this.detail.extra.evidence) {
          this.$message.error("请填写整改依据");
          return;
        }
        if (Array.isArray(this.detail.extra.problemList)) {
          let flag = false;
          this.detail.extra.problemList.forEach(item => {
            if (!item.measure) {
              flag = true;
            }
          });
          if (flag) {
            this.$message.error("请填写整改措施");
            return;
          }
        }
      }

        //  评审 - 管理级别必填
        if (this.isCosysPrjReview && this.detail.taskDefinitionKey && this.detail.taskDefinitionKey.startsWith('major_vice')) {
            if (!this.detail.extra.manageLevel) {
                this.$message.error("请选择管理级别");
                return;
            }
            if (!this.detail.extra.prjCategory) {
                this.$message.error("请选择项目类别");
                return;
            }
            map.manage_level = this.detail.extra.manageLevel;
            this.detail.extra.manageLevel = map.manage_level;
        }
        if (this.isCosysPrjReview && this.detail.taskDefinitionKey && this.detail.taskDefinitionKey.startsWith('submitter')) {
            if (!this.detail.extra.deptLeaderId && !this.detail.extra.deptLeaderName) {
                this.$message.error("请选择部门分管负责人");
                return;
            }
            if (!this.detail.extra.chiefEngineerId && !this.detail.extra.chiefEngineerName) {
                this.$message.error("请选择分管总工");
                return;
            }
            if (this.detail.extra.manageLevel === "company") {
                if (!this.detail.extra.companyLeaderId && !this.detail.extra.companyLeaderName) {
                    this.$message.error("请选择公司分管领导");
                    return;
                }
            }
            map.charger_dept = this.detail.extra.deptLeaderId || this.detail.extra.deptLeaderName;
            map.chief_engineer = this.detail.extra.chiefEngineerId || this.detail.extra.chiefEngineerName;
            if (this.detail.extra.manageLevel === "company") {
                map.charger_company = this.detail.extra.companyLeaderId || this.detail.extra.companyLeaderName;
            }
            this.detail.extra.chargerDept = map.charger_dept;
            this.detail.extra.chiefEngineer = map.chief_engineer;
            if (map.charger_company) {
                this.detail.extra.chargerCompany = map.charger_company;
            }
        }

      if (this.oa_it_asset_transfer_dept) {
        const arr =this.detail.extra.fixedAssetList.filter(v=>v.disposalMethod == 1)
        console.log(arr)
        if(arr.length > 0){
          if(!this.detail.extra.receiverId){
            this.$message.error("请选择原部门资产接收人");
            return
          }
        }
        let canAdd = true;
        this.detail.extra.fixedAssetList.forEach(item => {
          if (!(item.disposalMethod == 1 || item.disposalMethod == 0)){
            canAdd = false;
          }
        })
        if (!canAdd) {
          this.$message.error("请选择处置方式");
          return;
        }
      }
      console.log(map);

      this.control(map);
    },

    // 工单转单：选择新的待办人
    onSelectTransferUser(arr) {
      this.transferUser = arr && arr.length > 0 ? arr[0] : {};
    },

    control(map) {
      if (this.addApprovalDetail()) {
        console.log("文件未上传，阻止提交");
        return;
      }

      this.loading = true;
      const extra = JSON.parse(JSON.stringify(this.detail.extra));
      this.decodeExtraUrls(extra);
      // 工单申请：处理记录随extra提交（附件为文件id列表），业务回调解析extra存储
      if (this.isOaWorkOrder && this.isWorkOrderProcessNode) {
        extra.problemType = this.workOrderRecord.problemType;
        extra.modifyContent = this.workOrderRecord.modifyContent;
        // 是否收费随extra传递到后续节点，审批详情/工单详情据此展示（业务回调从map取值入库）
        extra.isCharge = this.workOrderRecord.isCharge === true;
        extra.processAttachment = this.workOrderRecord.files
          .map((item) => item.id || item.completePath || item)
          .join(",");
        // 补充附件文件数组随extra提交（与基本信息attachmentList同机制）：
        // activiti会把该extra传递到后续节点，审批详情/完成确认页据此展示附件文件名；
        // 业务回调则用processAttachment（id串）存库
        extra.processAttachmentList = this.workOrderRecord.files;
      }
      // 工单转单：转交人/转交部门随extra提交，业务回调解析extra反填业务字段
      // （task_transfer_process为assignee用户uuid，走流程变量，见上方转单处理处）
      if (this.isOaWorkOrder && this.transferUser.userId) {
        const org = this.transferUser.employeeOrgVo || {};
        extra.transferHandlerName = this.transferUser.name || "";
        extra.transferDeptId = org.id || "";
        extra.transferDeptName = org.name || "";
      }
      delete extra.seqNum
      let params = {
        notifyPeople: this.noticeList.map(item => item.userId),
        map,
        extra: JSON.stringify(extra)
      };
      if (this.isBiddingResult) {
        params.category = this.detail.category;
      }
      if (this.isBidJury) {
        params.passFlag = this.passFlag;
      }

      //完成任务前先校验：下一节点是否也是当前登录人的待办，是则弹窗确认是否自动审批；
      //用户点击"自动审批"后携带autoComplete=true提交，由后台递归自动完成
      checkAutoComplete({ taskId: this.currentTaskId, map })
        .catch(() => null) //校验接口异常不阻塞正常提交流程
        .then(res => {
          if (res && res.needAutoConfirm) {
            return new Promise(resolve => {
              this.$confirm({
                title: "自动审批",
                content: "检测到下一个节点也由您审批，是否需要自动审批通过？",
                okText: "自动审批",
                cancelText: "不自动审批",
                onOk: () => {
                  params.autoComplete = true;
                  resolve();
                },
                onCancel: () => {
                  resolve();
                }
              });
            });
          }
        })
        .then(() => this.finishTask(params))
        .then(() => {
          this.$emit("close");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 添加审批详情
    addApprovalDetail() {
      // 校验表单是否必填
      // 1.若为设计变更审批，分包签证事项且为最后一步（设计变更审批到设计负责人，分包签证到造价工程师）,且选择上传经决会意见，
      if (
        ((this.isVisa &&
          this.detail.taskDefinitionKey ===
            "general_contract_proj_dept_cost_engineer") ||
          (this.isChangeApproval &&
            this.detail.taskDefinitionKey === "design_dept_design_manager")) &&
        this.detail.extra.meetingComments &&
        !this.approvalList.length
      ) {
        this.$message.error("请上传经决会意见！");
        return true;
      }

      // 2.若为管理目标责任书，且为最后一步时,且选择上传经决会意见，
      // manage_dept_business_specialist
      if (
        this.isManageObject &&
        this.detail.taskDefinitionKey ===
          "general_contract_division_cost_manager"
      ) {
        if (!this.approvalList.length) {
          this.$message.error("请上传经决会意见！");
          return true;
        } else {
          this.detail.extra.planningData.attachmentList = Array.isArray(
            this.detail.extra.planningData.attachmentList
          )
            ? this.detail.extra.planningData.attachmentList
            : [];
          this.detail.extra.planningData.attachmentList.push(
            ...this.approvalList
          );
        }
      }
      // 3.若为索赔，反索赔,选择了不符合审计原则且为最后一步时,且选择上传经决会意见
      if (
        (this.isClaim || this.isCounterClaim) &&
        this.detail.taskDefinitionKey ===
          "general_contract_proj_dept_prj_manager" &&
        this.detail.extra.constructionData.suitAudit &&
        !this.approvalList.length
      ) {
        this.$message.error("请上传经决会意见！");
        return true;
      }

      // 把附件添加到extra中（解码URL）
      if (this.isChangeApproval) {
        for (const item of this.approvalList) {
          this.detail.extra.designData.attachmentList = Array.isArray(
            this.detail.extra.designData.attachmentList
          )
            ? this.detail.extra.designData.attachmentList
            : [];
          this.detail.extra.designData.attachmentList.push(item);
        }
      }
      if (
        this.isSafeInspection ||
        this.isQualityInspection ||
        this.isDataInspection ||
        this.isClaim ||
        this.isCounterClaim
      ) {
        for (const item of this.approvalList) {
          this.detail.extra.constructionData.attachmentList = Array.isArray(
            this.detail.extra.constructionData.attachmentList
          )
            ? this.detail.extra.constructionData.attachmentList
            : [];
          this.detail.extra.constructionData.attachmentList.push(item);
        }
      }
    },

    // 递归解码extra中所有附件URL的百分号编码并移除查询参数
    decodeExtraUrls(obj) {
      if (!obj || typeof obj !== 'object') return;
      if (Array.isArray(obj)) {
        obj.forEach(item => this.decodeExtraUrls(item));
      } else {
        Object.keys(obj).forEach(key => {
          const val = obj[key];
          const urlKeys = ['completePath', 'url', 'path', 'fileUrl', 'filePath', 'attachment', 'attachmentPath'];
          if (urlKeys.includes(key) && typeof val === 'string' && val.includes('%')) {
            try { obj[key] = this.decodeUrlPath(val); } catch (e) {}
          } else if (val && typeof val === 'object') {
            this.decodeExtraUrls(val);
          }
        });
      }
    },
    // 解码URL并移除查询参数（签名参数）
    decodeUrlPath(url) {
      return url
        .split(',')
        .map(part => {
          const qIndex = part.indexOf('?');
          if (qIndex === -1) return decodeURIComponent(part);
          return decodeURIComponent(part.substring(0, qIndex));
        })
        .join(',');
    },

    // 加签暂存
    tempSave() {
      this.signTaskStorage();
    },

    handleCommentChange(e) {
      this.setDetail({
        ...this.detail,
        comment: e.target.value
      });
    },
    // 保存选择的用户
    setNoticeList(payload) {
      this.noticeList = payload;
    },

    // 审批意见弹框 - 设置可见性
    setCommentVisible(visible) {
      this.commentVisible = visible;
    },

    // 审批意见弹框 - 用户填写完毕回调
    onCommentDone(comment) {
      if (this.pendingMap) {
        this.pendingMap.comment = comment;
        this.control(this.pendingMap);
      }
    },

    // 驳回确认弹框 - 取消
    handleRejectModalCancel() {
      this.rejectModalVisible = false;
    },

    // 驳回确认弹框 - 驳回发起人
    handleRejectToStarter() {
      this.rejectModalVisible = false;
      this.rejectToStarter();
    },

    // 驳回确认弹框 - 通过
    handleApprove() {
      this.rejectModalVisible = false;
      this.skipRejectModalCheck = true;
      this.save();
    },

    // 修改后重新发起审批
    reapply() {
        // 工具函数：获取带参数的完整路径
        const getFullPath = (basePath) => {
            const { taskId, instanceId } = this.$route.query;
            const separator = basePath.includes('?') ? '&' : '?';
            return `${basePath}${separator}taskId=${taskId}&instanceId=${instanceId}`;
        };

        // 工具函数：打开标签页 + 跳转
        const openTab = (path, name) => {
            const fullPath = getFullPath(path);
            const basePath = path.split('?')[0];
            const tabList = [...this.$store.state.tabs.tabList];

            if (!tabList.some(item => item.path === basePath)) {
                tabList.push({ name, path: basePath, fullPath });
                this.setTabList(tabList);
            }

            this.$router.push(fullPath).catch(() => {});
        };

        // 从 businessKey 获取 ID
        const getBusinessId = () => {
            const key = this.detail.businessKey || '';
            // businessKey 格式可能是：
            // 1. 简单格式：id:1517214225298165760
            // 2. 复合格式：id:1517214225298165760,DesignResultReplace:1516856236972249088
            if (!key) return '';

            // 按逗号分割，取第一部分
            const parts = key.split(',');
            const firstPart = parts[0];

            // 如果包含冒号，取冒号后面的部分
            if (firstPart.includes(':')) {
                return firstPart.split(':')[1];
            }
            return firstPart;
        };

        // 1. 校审审批跳转
        if (this.isAudit) {
            const id = getBusinessId();
            id && openTab(`/design-audit/detail/${id}`, '校审详情');
            return;
        }

        // 1.5 设计评审重新提交
        if (this.isReview) {
            const id = getBusinessId();
            id && openTab(`/review-reapply/${id}`, '重新提交设计评审');
            return;
        }

        // 2. 签章重新申请
        if (this.isCosysStampReview) {
            const id = getBusinessId();
            id && openTab(`/stamp-reapply/${id}`, '重新签章');
            return;
        }

        // 3. 会签评审重新申请
        if (this.isCosysPrjReview) {
            const id = getBusinessId();
            id && openTab(`/prj-reapply/${id}`, '重新会签评审');
            return;
        }

        // 3.5 任务通知单重新申请
        if (this.isCosysPrjTaskNotice) {
            const id = getBusinessId();
            id && openTab(`/notice-reapply/${id}`, '重新申请任务通知单');
            return;
        }

        // 3.6 设计方案修编重新提交
        if (this.isCosysDesignPlanRevise) {
            const id = getBusinessId();
            id && openTab(`/plan-revise-reapply/${id}`, '重新提交设计方案修编');
            return;
        }

        // 3.7 设计计划重新提交
        if (this.isCosysDesignPlan) {
            const id = getBusinessId();
            id && openTab(`/design-plan-reapply/${id}`, '重新提交设计计划');
            return;
        }

        // 3.8 设计会签重新提交
        if (this.isCosysDesignCountersign) {
            const id = getBusinessId();
            id && openTab(`/countersign-reapply/${id}`, '重新提交设计会签');
            return;
        }

        // 3.9 出版打印重新申请
        if (this.isCosysStampPrint) {
            const id = getBusinessId();
            id && openTab(`/print-reapply/${id}`, '重新申请出版打印');
            return;
        }

        // 3.10 设计确认重新提交
        if (this.isCosysDesignAffirm) {
            const id = getBusinessId();
            id && openTab(`/affirm-reapply/${id}`, '重新提交设计确认');
            return;
        }

        // 4. SCRM 外部链接
        if (this.isSCRM) {
            const url = this.detail?.extra?.url;
            url ? window.open(url) : this.$message.error('没有跳转链接');
            return;
        }

        // 3.11 设计评审重新提交
        if (this.isCosysDesignReview) {
            const id = getBusinessId();
            id && openTab(`/design-review-reapply/${id}`, '重新提交设计评审');
            return;
        }

        // 4.1 新scrm 项目备案
        if (this.isCosysProjectFiling){
          const id = getBusinessId();
          id && openTab(`/project-filing/${id}`, '重新提交项目备案');
          return;
        }
        // 4.2 新scrm 项目投标申请
        if (this.isCosysProjectBidApply){
          const id = getBusinessId();
          id && openTab(`/project-bid-apply/${id}`, '重新提交项目投标申请');
          return;
        }

        // 4.3 设计变更重新提交
        if (this.isCosysDesignChange) {
            const id = getBusinessId();
            id && openTab(`/design-change-reapply/${id}`, '重新提交设计变更');
            return;
        }

        // 4.4 设计归档重新提交
        if (this.isCosysDesignArchive) {
            const id = getBusinessId();
            id && openTab(`/archive-reapply/${id}`, '重新提交设计归档');
            return;
        }

        // 4.5 设计方案简表重新提交
        if (this.isCosysDesignPlanSimple) {
            const id = getBusinessId();
            id && openTab(`/simple-plan-reapply/${id}`, '重新提交设计方案简表');
            return;
        }

        // 4.6 设计输入需求重新提交
        if (this.isCosysDesignInputReq) {
            const id = getBusinessId();
            id && openTab(`/design-input-req-reapply/${id}`, '重新提交设计输入需求');
            return;
        }

        // 4.7 专业提资重新提交
        if (this.isCosysMajorTransfer) {
            const id = getBusinessId();
            id && openTab(`/major-transfer-reapply/${id}`, '重新提交专业提资');
            return;
        }

        // 4.8 服务报告重新提交
        if (this.isCosysDesignService) {
            const id = getBusinessId();
            id && openTab(`/design-service-reapply/${id}`, '重新提交服务报告');
            return;
        }

        // 4.9 竣工报告重新提交
        if (this.isCosysCompletionReport) {
            const id = getBusinessId();
            id && openTab(`/completion-report-reapply/${id}`, '重新提交竣工报告');
            return;
        }

        // 4.10 蓝图替换重新提交
        if (this.isCosysBlueprintReplace) {
            const id = getBusinessId();
            id && openTab(`/blueprint-replace-reapply/${id}`, '重新提交蓝图替换');
            return;
        }

        // 4.11 招标管理(创建标段)重新提交
        if (this.isAddBidding) {
            const id = getBusinessId();
            id && openTab(`/bidding-reapply/${id}`, '重新提交招标管理');
            return;
        }

        // 4.12 评标重新提交
        if (this.isBiddingResult) {
            const id = getBusinessId();
            id && openTab(`/evaluation-reapply/${id}`, '重新提交评标');
            return;
        }

        // 4.13 中标公示重新提交
        if (this.isBiddingConfirm) {
            const id = getBusinessId();
            // publicity 页面通过 query.id 获取标段id，需显式带上
            id && openTab(`/winbid-reapply/${id}?id=${id}`, '重新提交中标公示');
            return;
        }

        if (this.isOaLeave){
          const id = getBusinessId();
          id && openTab(`/oa-leave/${id}`, '重新提交离职申请');
          return;
        }

        if (this.isHrBranchEmployee){
          const id = getBusinessId();
          id && openTab(`/hr-branch-employee/${id}`, '重新提交员工瓴云账号信息填写表');
          return;
        }

        if (this.isPurchaseMaterials) {
          // 办公室外部采购申请
          const id = getBusinessId();
          id && openTab(`/oa/purchaseMaterialsRecord/edit?id=${id}`, '重新提交采购申请');
          return;
        }

        if (this.isOaWorkOrder) {
          // 工单申请（已驳回到发起人，修改后重新提交）
          const id = getBusinessId();
          id && openTab(`/oa/workOrder/edit?id=${id}&mode=resubmit`, '重新提交工单');
          return;
        }

      // 5. 默认跳转
        const url = this.getUrl();
        url ? this.$router.push(url) : this.$message.error('暂未开发，请联系系统管理员');
    },

    getUrl() {
      const text = this.detail;
      console.log("text", text);
      if (text.processDefinitionKey === "con_register") {
        // 跳转到合同登记页面
        const contractId = text.businessKey
          ? text.businessKey.substring(3)
          : "";

        return `/produce/contractRegister/review/add?id=${contractId}`;
      } else if (text.processDefinitionKey === "con_amount_adjust") {
        // 跳转到合同调整页面
        const id = this.detail?.extra?.contractChangeAmountData?.id;
        return `/produce/contract-adjust/add?taskId=${text.taskId}&instanceId=${text.processInstanceId}&id=${id}`;
      } else if (text.processDefinitionKey === "con_kj_register") {
        // 跳转到框架类合同登记页面
        const contractId = text.businessKey
          ? text.businessKey.substring(3)
          : "";

        return `/produce/contractRegister/framework/add?id=${contractId}`;
      } else if (text.processDefinitionKey === "subcon_register") {
        // 跳转到分包登记页面
        return `/produce/contractRegister/subpackage/add?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
      } else if (text.processDefinitionKey === "subcon_branch_register") {
        // 跳转到分院分包登记页面
        return `/produce/contractRegister/branchSubpackage/add?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
      } else if (text.processDefinitionKey === "con_configure") {
        // 跳转到合同编辑页面
        const contractId = text.businessKey
          ? text.businessKey.substring(3)
          : "";
        return `/produce/contract/edit?id=${contractId}`;
      } else if (text.processDefinitionKey === "prj_phase_progress") {
        const phase = this.detail.extra.phaseProgressData.phaseProgresses.map(item => item.phaseName)
        let id = text.businessKey
          ? text.businessKey.substring(3).split(",")[0]
          : "";
        return `/produce/progress/detail?id=${id}&phase=${phase.join(",")}`;
      } else if (text.processDefinitionKey === "fin_invoice") {
        return `/finance/invoice/apply?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
      } else if (text.processDefinitionKey === "prj_configure") {
        // 产值分配审批
        let id = text.businessKey
          ? text.businessKey.substring(3).split(",")[0]
          : "";

        const allocateCalcFormula =
          text?.extra?.staffConfigData?.contract?.allocateCalcFormula;
        const allocateCalcFactor =
          text?.extra?.staffConfigData?.contract?.allocateCalcFactor;

        console.log("allocateCalcFormula", allocateCalcFormula);
        console.log("allocateCalcFactor", allocateCalcFactor);

        if (allocateCalcFormula) {
          if (allocateCalcFormula === "2025") {
            return `/produce/progress/allocate2025?id=${id}&factor=${allocateCalcFactor}`;
          }else if (allocateCalcFormula === "2024") {
            return `/produce/progress/allocate2024?id=${id}&factor=${allocateCalcFactor}`;
          } else if (allocateCalcFormula === "2023") {
            return `/produce/progress/allocate2023?id=${id}&factor=${allocateCalcFactor}`;
          } else if (allocateCalcFormula === "2022") {
            return `/produce/progress/allocate2022?id=${id}&factor=${allocateCalcFactor}`;
          } else if (allocateCalcFormula === "2021") {
            return `/produce/progress/allocate2021?id=${id}`;
          }
        } else {
          return `/produce/progress/allocate?id=${id}`;
        }
      } else if (text.processDefinitionKey === "arc_borrow") {
        // 是否是档案出借审批
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/archive/query/lend?id=${id}`;
      } else if (text.processDefinitionKey === "arc_transfer") {
        // 是否是档案移交审批
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/archive/query/transfer?id=${id}`;
      } else if (text.processDefinitionKey === "ofc_inv_apply") {
        // 是否是酒水审批
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/material/apply?id=${id}`;
      } else if (text.processDefinitionKey === "ofc_gift_apply") {
        // 是否是礼品审批
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/gift/apply?id=${id}`;
      } else if (text.processDefinitionKey === "ofc_entertain_apply") {
        // 是否是招待费申请
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/entertain/apply?id=${id}`;
      } else if (text.processDefinitionKey === "oa_purchase_materials") {
        // 是否是礼品审批
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/purchaseMaterials/apply?id=${id}`;
      } else if (text.processDefinitionKey === "oa_it_asset_apply") {
        // 是否是固定资产审批
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/fixedAssets/apply?id=${id}`;
      } else if (text.processDefinitionKey === "oa_it_asset_transfer") {
        // 是否是固定资产移交
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/fixedAssetsBook/handover?id=${id}`;
      } else if (text.processDefinitionKey === "oa_it_asset_scrap") {
        // 是否是it固定资产待报废
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/fixedAssets/scrap/0?id=${id}`;
      } else if (text.processDefinitionKey === "oa_asset_scrap") {
        // 是否是固定资产待报废
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/fixedAssets/scrap/1?id=${id}`;
      } else if (text.processDefinitionKey === "oa_asset_scrap_disposal") {
        // 是否是固定资产报废处置
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/oa/fixedAssets/handleScrap?id=${id}`;
      }else if (
        text.processDefinitionKey === "att_leave" ||
        text.processDefinitionKey === "att_on_business"
      ) {
        // 请假审批/出差或公出审批
        const { id, type } = text.extra || {};
        return `/human-resources/clock/add?type=${type}&id=${id}&control=resubmit`;
      } else if (text.processDefinitionKey === "att_check_apply") {
        // 补卡审批
        const { id } = text.extra || {};
        return `/human-resources/clock/replace?id=${id}`;
      } else if (text.processDefinitionKey === "ofc_quality_plan") {
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/technical-quality/security-check-management/security-check/detail?id=${id}`;
      } else if (text.processDefinitionKey === "ofc_quality_work") {
        const { parentId } = text.extra || {};
        return `/technical-quality/security-check-management/security-check/detail?id=${parentId}&active=1`;
      } else if (text.processDefinitionKey === "ofc_quality_rectify") {
        const { parentId } = text.extra || {};
        return `/technical-quality/security-check-management/security-check/detail?id=${parentId}&active=2`;
      } else if (text.processDefinitionKey === "safety_collaborate") {
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/collaborate?id=${id}`;
      }  else if (text.processDefinitionKey === "scrm_exclusive_area") {
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/market/exclusiveArea?id=${id}`;
      } else if (text.processDefinitionKey === "scrm_channel") {
        const id = text.businessKey ? text.businessKey.substring(3) : "";
        return `/market/channelRegistration?id=${id}`;
      } else if (text.processDefinitionKey === "cosys_stamp_review") {
        const businessKey = text.businessKey || '';
        const id = businessKey.includes(':') ? businessKey.split(':')[1] : businessKey;
        return `/stamp-reapply/${id}?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
      } else if (text.processDefinitionKey === "cosys_prj_review") {
        const businessKey = text.businessKey || '';
        const id = businessKey.includes(':') ? businessKey.split(':')[1] : businessKey;
        return `/prj-reapply/${id}?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
      } else if (text.processDefinitionKey === "cosys_design_review") {
          const businessKey = text.businessKey || '';
          const id = businessKey.includes(':') ? businessKey.split(':')[1] : businessKey;
          return `/design-review-reapply/${id}?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
      } else if (text.processDefinitionKey === "cosys_stamp_print") {
        const businessKey = text.businessKey || '';
        const id = businessKey.includes(':') ? businessKey.split(':')[1] : businessKey;
        return `/print-reapply/${id}?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
      }else if (text.processDefinitionKey === "cosys_blueprint_replace") {
          // 蓝图替换审批
          const businessKey = text.businessKey || '';
          // businessKey 格式：id:1517214225298165760,DesignResultReplace:1516856236972249088
          // 提取第一个 id
          const parts = businessKey.split(',');
          const firstPart = parts[0] || '';
          const id = firstPart.includes(':') ? firstPart.split(':')[1] : firstPart;
          return `/blueprint-replace-reapply/${id}?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
      } else if (text.processDefinitionKey === "finance_payment_subcontract" || text.processDefinitionKey === "finance_payment_subcontract_branch") {
        // 分包支付审批（根据 paymentType 判断总院还是分院）
        const paymentType = text.extra?.paymentType;
        if (paymentType === 'branch_institute') {
          // 分院
          return `/finance/transaction/subpackage-payment/branch-institute?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
        } else {
          // 总院（默认）
          return `/finance/transaction/subpackage-payment/main-institute?taskId=${text.taskId}&instanceId=${text.processInstanceId}`;
        }
      } else {
        return "";
      }
    }
  },
  beforeDestroy() {
    this.setSignUser([]);
    this.setSignType("");
    this.setOnSet(false);
  }
};
</script>

<style lang="less" scoped>
.button {
  display: flex;
  align-items: center;
  color: #1890ff;
  border-color: #1890ff;

  .icon {
    height: 10px;
    margin-right: 2px;
  }
}

.menu-item {
  display: flex;
  align-items: center;

  .icon {
    height: 12px;
    margin-right: 6px;
  }
}

.control {
  position: absolute;
  top: 56px;
  right: 12px;
  z-index: 99;
}

.scroll-link {
  cursor: pointer;
  text-decoration: underline;
}

.scroll-link:hover {
  color: #40a9ff;
}
</style>
